import request from '../../js/lib/request';
import urlVars from '../../js/lib/urlVars';

const newsBlocks = document.querySelectorAll('.NewsBlock');
if (newsBlocks.length !== 0) 
{
	// Use different URL for Static/MVC
	for (var x = 0; x < newsBlocks.length; x++) 
	{
		const id = newsBlocks[x].id;
		const url = `/NewsBlock/Refine/?b=` + id.replace(/^NewsBlock_/, '');

		const NewsBlockComp = new Vue({
			el: '#' + id,
			data: {
				isLoading: false,
			},
			mounted: function() {
				const self = this;
				self.cats = self.FT_cats;

				var qs = urlVars();

				if(qs["cat"] && self.$refs.catDD)
					self.$refs.catDD.value = qs["cat"];

				self.refreshAllResults();

			},
			methods: {
					refreshAllResults: function() {
						const self = this;
		
						self.isLoading = true;

						var thisUrl = url;
						if(self.$refs.yearDD != null)
						{
							// make sure both dd's have a value
							if(self.$refs.quarterDD.value.length <= 0)
								self.$refs.quarterDD.value = self.$refs.quarterDD.children[1].value;

							if(self.$refs.yearDD.value == 0)
								self.$refs.quarterDD.value = self.$refs.quarterDD.children[0].value;
	
							// post
							thisUrl = thisUrl + '&year=' + self.$refs.yearDD.value + '&quarter=' + self.$refs.quarterDD.value;
						}
						else
							thisUrl = thisUrl + '&cat=' + self.$refs.catDD.value;
	
						request().get(thisUrl).then(function(response) {
							self.$refs['newsContent'].innerHTML = response;
							self.isLoading = false;
						});
					},
				}
			});
	}
}




// WEBPACK FOOTER //
// ../components/news/news.js